/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SentryTestRouteImport } from './routes/sentry-test'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as AuthedAccountsRouteImport } from './routes/_authed.accounts'
import { Route as AuthedAdminRouteImport } from './routes/_authed.admin'
import { Route as AuthedAmsRouteImport } from './routes/_authed.ams'
import { Route as AuthedCampaignsRouteImport } from './routes/_authed.campaigns'
import { Route as AuthedContactsRouteImport } from './routes/_authed.contacts'
import { Route as AuthedDashboardRouteImport } from './routes/_authed.dashboard'
import { Route as AuthedImportRouteImport } from './routes/_authed.import'
import { Route as AuthedPipelineRouteImport } from './routes/_authed.pipeline'
import { Route as AuthedPosRouteImport } from './routes/_authed.pos'
import { Route as AuthedProductsRouteImport } from './routes/_authed.products'
import { Route as AuthedProfileRouteImport } from './routes/_authed.profile'
import { Route as AuthedReportsRouteImport } from './routes/_authed.reports'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedTasksRouteImport } from './routes/_authed.tasks'
import { Route as AuthedAccountsIndexRouteImport } from './routes/_authed.accounts.index'
import { Route as AuthedAccountsAccountIdRouteImport } from './routes/_authed.accounts.$accountId'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed.admin.index'
import { Route as AuthedAdminModulesRouteImport } from './routes/_authed.admin.modules'
import { Route as AuthedAdminTeamAccessRouteImport } from './routes/_authed.admin.team-access'
import { Route as AuthedContactsIndexRouteImport } from './routes/_authed.contacts.index'
import { Route as AuthedContactsContactIdRouteImport } from './routes/_authed.contacts.$contactId'
import { Route as AuthedPipelineIndexRouteImport } from './routes/_authed.pipeline.index'
import { Route as AuthedPipelineIdRouteImport } from './routes/_authed.pipeline.$id'
import { Route as AuthedProfileIndexRouteImport } from './routes/_authed.profile.index'
import { Route as AuthedProfileSecurityRouteImport } from './routes/_authed.profile.security'
import { Route as AuthedSettingsBrandingRouteImport } from './routes/_authed.settings.branding'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SentryTestRoute = SentryTestRouteImport.update({
  id: '/sentry-test',
  path: '/sentry-test',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountsRoute = AuthedAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAmsRoute = AuthedAmsRouteImport.update({
  id: '/ams',
  path: '/ams',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCampaignsRoute = AuthedCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedContactsRoute = AuthedContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedImportRoute = AuthedImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPipelineRoute = AuthedPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPosRoute = AuthedPosRouteImport.update({
  id: '/pos',
  path: '/pos',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProductsRoute = AuthedProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTasksRoute = AuthedTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAccountsIndexRoute = AuthedAccountsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAccountsRoute,
} as any)
const AuthedAccountsAccountIdRoute = AuthedAccountsAccountIdRouteImport.update({
  id: '/$accountId',
  path: '/$accountId',
  getParentRoute: () => AuthedAccountsRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminModulesRoute = AuthedAdminModulesRouteImport.update({
  id: '/modules',
  path: '/modules',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminTeamAccessRoute = AuthedAdminTeamAccessRouteImport.update({
  id: '/team-access',
  path: '/team-access',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedContactsIndexRoute = AuthedContactsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedContactsRoute,
} as any)
const AuthedContactsContactIdRoute = AuthedContactsContactIdRouteImport.update({
  id: '/$contactId',
  path: '/$contactId',
  getParentRoute: () => AuthedContactsRoute,
} as any)
const AuthedPipelineIndexRoute = AuthedPipelineIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedPipelineRoute,
} as any)
const AuthedPipelineIdRoute = AuthedPipelineIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedPipelineRoute,
} as any)
const AuthedProfileIndexRoute = AuthedProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedProfileRoute,
} as any)
const AuthedProfileSecurityRoute = AuthedProfileSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthedProfileRoute,
} as any)
const AuthedSettingsBrandingRoute = AuthedSettingsBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AuthedSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/sentry-test': typeof SentryTestRoute
  '/accounts': typeof AuthedAccountsRouteWithChildren
  '/admin': typeof AuthedAdminRouteWithChildren
  '/ams': typeof AuthedAmsRoute
  '/campaigns': typeof AuthedCampaignsRoute
  '/contacts': typeof AuthedContactsRouteWithChildren
  '/dashboard': typeof AuthedDashboardRoute
  '/import': typeof AuthedImportRoute
  '/pipeline': typeof AuthedPipelineRouteWithChildren
  '/pos': typeof AuthedPosRoute
  '/products': typeof AuthedProductsRoute
  '/profile': typeof AuthedProfileRouteWithChildren
  '/reports': typeof AuthedReportsRoute
  '/settings': typeof AuthedSettingsRouteWithChildren
  '/tasks': typeof AuthedTasksRoute
  '/accounts/$accountId': typeof AuthedAccountsAccountIdRoute
  '/admin/modules': typeof AuthedAdminModulesRoute
  '/admin/team-access': typeof AuthedAdminTeamAccessRoute
  '/contacts/$contactId': typeof AuthedContactsContactIdRoute
  '/pipeline/$id': typeof AuthedPipelineIdRoute
  '/profile/security': typeof AuthedProfileSecurityRoute
  '/settings/branding': typeof AuthedSettingsBrandingRoute
  '/accounts/': typeof AuthedAccountsIndexRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/contacts/': typeof AuthedContactsIndexRoute
  '/pipeline/': typeof AuthedPipelineIndexRoute
  '/profile/': typeof AuthedProfileIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/sentry-test': typeof SentryTestRoute
  '/ams': typeof AuthedAmsRoute
  '/campaigns': typeof AuthedCampaignsRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/import': typeof AuthedImportRoute
  '/pos': typeof AuthedPosRoute
  '/products': typeof AuthedProductsRoute
  '/reports': typeof AuthedReportsRoute
  '/settings': typeof AuthedSettingsRouteWithChildren
  '/tasks': typeof AuthedTasksRoute
  '/': typeof AuthedIndexRoute
  '/accounts/$accountId': typeof AuthedAccountsAccountIdRoute
  '/admin/modules': typeof AuthedAdminModulesRoute
  '/admin/team-access': typeof AuthedAdminTeamAccessRoute
  '/contacts/$contactId': typeof AuthedContactsContactIdRoute
  '/pipeline/$id': typeof AuthedPipelineIdRoute
  '/profile/security': typeof AuthedProfileSecurityRoute
  '/settings/branding': typeof AuthedSettingsBrandingRoute
  '/accounts': typeof AuthedAccountsIndexRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/contacts': typeof AuthedContactsIndexRoute
  '/pipeline': typeof AuthedPipelineIndexRoute
  '/profile': typeof AuthedProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/sentry-test': typeof SentryTestRoute
  '/_authed/accounts': typeof AuthedAccountsRouteWithChildren
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/ams': typeof AuthedAmsRoute
  '/_authed/campaigns': typeof AuthedCampaignsRoute
  '/_authed/contacts': typeof AuthedContactsRouteWithChildren
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/import': typeof AuthedImportRoute
  '/_authed/pipeline': typeof AuthedPipelineRouteWithChildren
  '/_authed/pos': typeof AuthedPosRoute
  '/_authed/products': typeof AuthedProductsRoute
  '/_authed/profile': typeof AuthedProfileRouteWithChildren
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/settings': typeof AuthedSettingsRouteWithChildren
  '/_authed/tasks': typeof AuthedTasksRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/accounts/$accountId': typeof AuthedAccountsAccountIdRoute
  '/_authed/admin/modules': typeof AuthedAdminModulesRoute
  '/_authed/admin/team-access': typeof AuthedAdminTeamAccessRoute
  '/_authed/contacts/$contactId': typeof AuthedContactsContactIdRoute
  '/_authed/pipeline/$id': typeof AuthedPipelineIdRoute
  '/_authed/profile/security': typeof AuthedProfileSecurityRoute
  '/_authed/settings/branding': typeof AuthedSettingsBrandingRoute
  '/_authed/accounts/': typeof AuthedAccountsIndexRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/contacts/': typeof AuthedContactsIndexRoute
  '/_authed/pipeline/': typeof AuthedPipelineIndexRoute
  '/_authed/profile/': typeof AuthedProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/sentry-test'
    | '/accounts'
    | '/admin'
    | '/ams'
    | '/campaigns'
    | '/contacts'
    | '/dashboard'
    | '/import'
    | '/pipeline'
    | '/pos'
    | '/products'
    | '/profile'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/accounts/$accountId'
    | '/admin/modules'
    | '/admin/team-access'
    | '/contacts/$contactId'
    | '/pipeline/$id'
    | '/profile/security'
    | '/settings/branding'
    | '/accounts/'
    | '/admin/'
    | '/contacts/'
    | '/pipeline/'
    | '/profile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/sentry-test'
    | '/ams'
    | '/campaigns'
    | '/dashboard'
    | '/import'
    | '/pos'
    | '/products'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/'
    | '/accounts/$accountId'
    | '/admin/modules'
    | '/admin/team-access'
    | '/contacts/$contactId'
    | '/pipeline/$id'
    | '/profile/security'
    | '/settings/branding'
    | '/accounts'
    | '/admin'
    | '/contacts'
    | '/pipeline'
    | '/profile'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/sentry-test'
    | '/_authed/accounts'
    | '/_authed/admin'
    | '/_authed/ams'
    | '/_authed/campaigns'
    | '/_authed/contacts'
    | '/_authed/dashboard'
    | '/_authed/import'
    | '/_authed/pipeline'
    | '/_authed/pos'
    | '/_authed/products'
    | '/_authed/profile'
    | '/_authed/reports'
    | '/_authed/settings'
    | '/_authed/tasks'
    | '/_authed/'
    | '/_authed/accounts/$accountId'
    | '/_authed/admin/modules'
    | '/_authed/admin/team-access'
    | '/_authed/contacts/$contactId'
    | '/_authed/pipeline/$id'
    | '/_authed/profile/security'
    | '/_authed/settings/branding'
    | '/_authed/accounts/'
    | '/_authed/admin/'
    | '/_authed/contacts/'
    | '/_authed/pipeline/'
    | '/_authed/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SentryTestRoute: typeof SentryTestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sentry-test': {
      id: '/sentry-test'
      path: '/sentry-test'
      fullPath: '/sentry-test'
      preLoaderRoute: typeof SentryTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/accounts': {
      id: '/_authed/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AuthedAccountsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ams': {
      id: '/_authed/ams'
      path: '/ams'
      fullPath: '/ams'
      preLoaderRoute: typeof AuthedAmsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/campaigns': {
      id: '/_authed/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthedCampaignsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/contacts': {
      id: '/_authed/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthedContactsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/import': {
      id: '/_authed/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AuthedImportRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pipeline': {
      id: '/_authed/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof AuthedPipelineRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pos': {
      id: '/_authed/pos'
      path: '/pos'
      fullPath: '/pos'
      preLoaderRoute: typeof AuthedPosRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/products': {
      id: '/_authed/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthedProductsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tasks': {
      id: '/_authed/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthedTasksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/accounts/': {
      id: '/_authed/accounts/'
      path: '/'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AuthedAccountsIndexRouteImport
      parentRoute: typeof AuthedAccountsRoute
    }
    '/_authed/accounts/$accountId': {
      id: '/_authed/accounts/$accountId'
      path: '/$accountId'
      fullPath: '/accounts/$accountId'
      preLoaderRoute: typeof AuthedAccountsAccountIdRouteImport
      parentRoute: typeof AuthedAccountsRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/modules': {
      id: '/_authed/admin/modules'
      path: '/modules'
      fullPath: '/admin/modules'
      preLoaderRoute: typeof AuthedAdminModulesRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/team-access': {
      id: '/_authed/admin/team-access'
      path: '/team-access'
      fullPath: '/admin/team-access'
      preLoaderRoute: typeof AuthedAdminTeamAccessRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/contacts/': {
      id: '/_authed/contacts/'
      path: '/'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AuthedContactsIndexRouteImport
      parentRoute: typeof AuthedContactsRoute
    }
    '/_authed/contacts/$contactId': {
      id: '/_authed/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AuthedContactsContactIdRouteImport
      parentRoute: typeof AuthedContactsRoute
    }
    '/_authed/pipeline/': {
      id: '/_authed/pipeline/'
      path: '/'
      fullPath: '/pipeline/'
      preLoaderRoute: typeof AuthedPipelineIndexRouteImport
      parentRoute: typeof AuthedPipelineRoute
    }
    '/_authed/pipeline/$id': {
      id: '/_authed/pipeline/$id'
      path: '/$id'
      fullPath: '/pipeline/$id'
      preLoaderRoute: typeof AuthedPipelineIdRouteImport
      parentRoute: typeof AuthedPipelineRoute
    }
    '/_authed/profile/': {
      id: '/_authed/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthedProfileIndexRouteImport
      parentRoute: typeof AuthedProfileRoute
    }
    '/_authed/profile/security': {
      id: '/_authed/profile/security'
      path: '/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof AuthedProfileSecurityRouteImport
      parentRoute: typeof AuthedProfileRoute
    }
    '/_authed/settings/branding': {
      id: '/_authed/settings/branding'
      path: '/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof AuthedSettingsBrandingRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
  }
}

interface AuthedAccountsRouteChildren {
  AuthedAccountsAccountIdRoute: typeof AuthedAccountsAccountIdRoute
  AuthedAccountsIndexRoute: typeof AuthedAccountsIndexRoute
}

const AuthedAccountsRouteChildren: AuthedAccountsRouteChildren = {
  AuthedAccountsAccountIdRoute: AuthedAccountsAccountIdRoute,
  AuthedAccountsIndexRoute: AuthedAccountsIndexRoute,
}

const AuthedAccountsRouteWithChildren = AuthedAccountsRoute._addFileChildren(
  AuthedAccountsRouteChildren,
)

interface AuthedAdminRouteChildren {
  AuthedAdminModulesRoute: typeof AuthedAdminModulesRoute
  AuthedAdminTeamAccessRoute: typeof AuthedAdminTeamAccessRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminModulesRoute: AuthedAdminModulesRoute,
  AuthedAdminTeamAccessRoute: AuthedAdminTeamAccessRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedContactsRouteChildren {
  AuthedContactsContactIdRoute: typeof AuthedContactsContactIdRoute
  AuthedContactsIndexRoute: typeof AuthedContactsIndexRoute
}

const AuthedContactsRouteChildren: AuthedContactsRouteChildren = {
  AuthedContactsContactIdRoute: AuthedContactsContactIdRoute,
  AuthedContactsIndexRoute: AuthedContactsIndexRoute,
}

const AuthedContactsRouteWithChildren = AuthedContactsRoute._addFileChildren(
  AuthedContactsRouteChildren,
)

interface AuthedPipelineRouteChildren {
  AuthedPipelineIdRoute: typeof AuthedPipelineIdRoute
  AuthedPipelineIndexRoute: typeof AuthedPipelineIndexRoute
}

const AuthedPipelineRouteChildren: AuthedPipelineRouteChildren = {
  AuthedPipelineIdRoute: AuthedPipelineIdRoute,
  AuthedPipelineIndexRoute: AuthedPipelineIndexRoute,
}

const AuthedPipelineRouteWithChildren = AuthedPipelineRoute._addFileChildren(
  AuthedPipelineRouteChildren,
)

interface AuthedProfileRouteChildren {
  AuthedProfileSecurityRoute: typeof AuthedProfileSecurityRoute
  AuthedProfileIndexRoute: typeof AuthedProfileIndexRoute
}

const AuthedProfileRouteChildren: AuthedProfileRouteChildren = {
  AuthedProfileSecurityRoute: AuthedProfileSecurityRoute,
  AuthedProfileIndexRoute: AuthedProfileIndexRoute,
}

const AuthedProfileRouteWithChildren = AuthedProfileRoute._addFileChildren(
  AuthedProfileRouteChildren,
)

interface AuthedSettingsRouteChildren {
  AuthedSettingsBrandingRoute: typeof AuthedSettingsBrandingRoute
}

const AuthedSettingsRouteChildren: AuthedSettingsRouteChildren = {
  AuthedSettingsBrandingRoute: AuthedSettingsBrandingRoute,
}

const AuthedSettingsRouteWithChildren = AuthedSettingsRoute._addFileChildren(
  AuthedSettingsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAccountsRoute: typeof AuthedAccountsRouteWithChildren
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedAmsRoute: typeof AuthedAmsRoute
  AuthedCampaignsRoute: typeof AuthedCampaignsRoute
  AuthedContactsRoute: typeof AuthedContactsRouteWithChildren
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedImportRoute: typeof AuthedImportRoute
  AuthedPipelineRoute: typeof AuthedPipelineRouteWithChildren
  AuthedPosRoute: typeof AuthedPosRoute
  AuthedProductsRoute: typeof AuthedProductsRoute
  AuthedProfileRoute: typeof AuthedProfileRouteWithChildren
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedSettingsRoute: typeof AuthedSettingsRouteWithChildren
  AuthedTasksRoute: typeof AuthedTasksRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAccountsRoute: AuthedAccountsRouteWithChildren,
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedAmsRoute: AuthedAmsRoute,
  AuthedCampaignsRoute: AuthedCampaignsRoute,
  AuthedContactsRoute: AuthedContactsRouteWithChildren,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedImportRoute: AuthedImportRoute,
  AuthedPipelineRoute: AuthedPipelineRouteWithChildren,
  AuthedPosRoute: AuthedPosRoute,
  AuthedProductsRoute: AuthedProductsRoute,
  AuthedProfileRoute: AuthedProfileRouteWithChildren,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedSettingsRoute: AuthedSettingsRouteWithChildren,
  AuthedTasksRoute: AuthedTasksRoute,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  SentryTestRoute: SentryTestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
